import { Layout, Button } from 'antd';
import { withRouter } from 'react-router';
import { LeftOutlined } from '@ant-design/icons';
import SidebarMenu from './SidebarMenu';
import ITVLogo from '../../assets/icons/logo.png';
import ITVLogoPng from '../../assets/images/logo_innotech_vietnam.png';
import styled from 'styled-components';
import { useLayoutDesktopContext } from 'contexts/LayoutDesktopContext';
import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import { getUser } from 'utils/auth';
import { PERMISSION_DASHBOARD_ACCESS } from 'constants/permissions';
import { useAppDispatch } from 'app/hooks';
import { setIsCheckSelectionDetail } from 'features/configuration/configurationSlice';

const { Sider } = Layout;

const SlideBar = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { collapsedslidebar, onCollapsedSlideBar } = useLayoutDesktopContext();
  const [isHovered, setIsHovered] = useState(false);

  const handleGoBack = () => {
    dispatch(setIsCheckSelectionDetail(true));
    history.replace('/module-selection');
  };
  const isPermissionsUser = getUser()?.permissions?.includes(PERMISSION_DASHBOARD_ACCESS.DASHBOARD_ACCESS_HR)

  return (
    <Sider
      collapsible
      collapsed={collapsedslidebar}
      onCollapse={(value) => onCollapsedSlideBar(value)}
      width={250}
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
        zIndex: 502,
      }}
    >
      <LogoLayout onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
        {isPermissionsUser && (
          <BackButtonWrapper>
          <BackButton icon={<LeftOutlined />} onClick={handleGoBack} type="text" />
        </BackButtonWrapper>
        )}
        {isPermissionsUser && isHovered ? (
          <LogoText onClick={handleGoBack}>HRM Module</LogoText>
        ) : (
          <LogoImage src={!collapsedslidebar ? ITVLogo : ITVLogoPng} alt="Itv logo" />
        )}
      </LogoLayout>
      <SidebarMenu />
    </Sider>
  );
};

const LogoImage = styled.img`
  margin-top: 0.2rem;
  height: 50px;
`;

const BackButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.65);
  transition: all ease 0.3s;

  .anticon {
    font-size: 20px;
    font-weight: 700 !important;
  }
`;

const LogoText = styled.div`
  color: white;
  font-size: 18px;
  font-weight: 600;
  margin-top: 0.2rem;
  height: 50px;
  display: flex;
  align-items: center;
  margin-left: -40px;
  cursor: pointer;
  transition: all ease 0.3s;
`;

const BackButtonWrapper = styled.div`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
`;

const LogoLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  margin: 5px 0;
  position: relative;

  &:hover {
    ${BackButton} {
      color: white;
      transform: translateX(-10px);
    }

    ${LogoText} {
      transform: translateX(-10px);
    }
  }
`;

export default withRouter(SlideBar);
